<template>

    <div class="form-group" ref="imageSelect">
        <label v-if="hideLabel === false">{{ element.display_name }}</label>
        <file-manager-image-select
            v-model="element.value"
            :mime-types="mimeTypes"
            :crop-available="true"
            :crop-aspect-ratio="cropAspectRatio"
            :width="width"
            :additional-hint="additionalHint"
            :hide-hints="hideLabel"
            @change="handleInput"
        ></file-manager-image-select>
        <div class="d-block invalid-feedback" v-if="error">{{ error }}</div>
    </div>

</template>

<script>

import Image from "../file-manager/classes/Image";
import mime from 'mime';

export default {

    name: 'PersonalizedGameEditorImage',

    props: {
        value: Object,
        location: String,
        hideLabel: Boolean,
        mimeTypes: String
    },

    data() {
        return {
            eventHub: window.eventHub,
            element: this.value,
            cropAspectRatio: NaN,
            error: null,
            minPreviewWidth: 150,
            maxPreviewWidth: 250,
            additionalHint: ''
        }
    },

    computed: {
        width() {
            if (this.element.min_width < this.minPreviewWidth) {
                return this.minPreviewWidth;
            }
            if (this.element.max_width > this.maxPreviewWidth) {
                return this.maxPreviewWidth;
            }
            return this.element.max_width;
        },
        elementLocation() {
            if (this.location) {
                return this.location + '.' + this.element.name;
            }
            return this.element.name
        }
    },

    beforeMount() {
        // If max width/height are same as min width/height, then set aspect ratio for cropping
        if (
            this.element.max_height && this.element.min_height && this.element.max_width && this.element.min_width &&
            this.element.max_height === this.element.min_height && this.element.max_width === this.element.min_width
        ) {
            this.cropAspectRatio = this.element.max_width / this.element.max_height;
        }
        this.element.value = new Image(this.element.value);

        if (this.element.preferred_mime_type) {
            const preferredExtensions = Array.from(mime.getAllExtensions(this.element.preferred_mime_type))
            this.additionalHint += '<strong>' + t.__('Zalecane rozszerzenie pliku: ') + preferredExtensions.join(', ') + '.</strong><br/>'
        }
        console.log(this.additionalHint);

        if (this.element.min_width >= 0 || this.element.max_width >= 0) {
            if (this.element.min_width === this.element.max_width) {
                this.additionalHint += 'Szerokość: ' + this.element.min_width + ' px.<br/>';
            } else {
                this.additionalHint += 'Szerokość: ';
                if (this.element.min_width > 0) {
                    this.additionalHint += 'min. ' + this.element.min_width + ' px. ';
                }
                if (this.element.max_width > 0) {
                    this.additionalHint += 'max. ' + this.element.max_width + ' px.';
                }
                this.additionalHint += '<br/>';
            }
        }

        if (this.element.min_height >= 0 || this.element.max_height >= 0) {
            if (this.element.min_height === this.element.max_height) {
                this.additionalHint += 'Wysokość: ' + this.element.min_height + ' px.<br/>';
            } else {
                this.additionalHint += 'Wysokość: ';
                if (this.element.min_height > 0) {
                    this.additionalHint += 'min. ' + this.element.min_height + ' px. ';
                }
                if (this.element.max_height > 0) {
                    this.additionalHint += 'max. ' + this.element.max_height + ' px.';
                }
                this.additionalHint += '<br/>';
            }
        }


    },

    mounted() {
        this.setMaxWidth();
        window.addEventListener('resize', this.setMaxWidth);
        this.eventHub.$on('personalized-games-update-errors', errors => {
            if (errors[this.elementLocation] !== undefined) {
                this.error = errors[this.elementLocation];
            } else {
                this.error = null;
            }
        });
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.setMaxWidth);
    },

    methods: {
        setMaxWidth() {
            this.maxPreviewWidth = 250;
            this.$nextTick(() => {
                const parentWidth = this.$refs.imageSelect.parentElement.offsetWidth;
                if (parentWidth) {
                    this.maxPreviewWidth = parentWidth;
                } else {
                    this.maxPreviewWidth = 250;
                }
            });
        },
        handleInput (e) {
            this.$emit('input', this.element)
        }
    }

}
</script>


